import { CategoryId } from "@/services/collection/categories/categoriesSchema";
import { gettext } from "@/services/translation";
import type { Category } from "@/services/collection/categories";

export const createArticleListPageTitle = (category: Category | undefined) => {
  let title = gettext.$gettext("Magazín");
  const categoryId = category?.id;

  if (categoryId === CategoryId.LegoMinifigures) {
    title = gettext.$gettext("Magazín o LEGO figurkách");
  } else if (categoryId === CategoryId.LegoSets) {
    title = gettext.$gettext("Magazín pro fanoušky LEGO setů");
  } else if (categoryId === CategoryId.Watches) {
    title = gettext.$gettext("Magazín pro fanoušky hodinek");
  } else if (categoryId === CategoryId.Shoes) {
    title = gettext.$gettext("Novinky ze světa tenisek");
  } else if (categoryId === CategoryId.VinylRecords) {
    title = gettext.$gettext("Magazín o vinylových deskách");
  } else if (categoryId === CategoryId.BoardGames) {
    title = gettext.$gettext("Magazín pro fanoušky deskovek");
  } else if (categoryId === CategoryId.Alcohol) {
    title = gettext.$gettext("Sběratelský alkohol pod lupou");
  } else if (categoryId === CategoryId.MoviePosters) {
    title = gettext.$gettext("Magazín plný filmových plakátů");
  } else if (categoryId === CategoryId.FunkoPop) {
    title = gettext.$gettext("Magazín o FunkoPOP figurkách");
  } else if (categoryId === CategoryId.Books) {
    title = gettext.$gettext("Exkluzivní články o knihách");
  } else if (categoryId === CategoryId.Comics) {
    title = gettext.$gettext("Exkluzivní články o komiksech");
  } else if (categoryId === CategoryId.MagicTheGathering) {
    title = gettext.$gettext("Tipy a triky pro MTG hráče");
  } else if (categoryId === CategoryId.Perfumes) {
    title = gettext.$gettext("Inspirace pro milovníky parfémů");
  } else if (categoryId === CategoryId.Pokemon) {
    title = gettext.$gettext("Magazín pro fanoušky Pokémonů");
  } else if (categoryId === CategoryId.Porcelain) {
    title = gettext.$gettext("Tipy pro sběratele porcelánu");
  } else if (categoryId === CategoryId.SportsCards) {
    title = gettext.$gettext("Magazín o sportovních kartách");
  } else if (categoryId === CategoryId.Art) {
    title = gettext.$gettext("Magazín o umění a sběratelství");
  } else if (categoryId === CategoryId.Weapons) {
    title = gettext.$gettext("Magazín o starožitných zbraních");
  } else if (categoryId === CategoryId.Stamps) {
    title = gettext.$gettext("Filatelistický magazín pro sběratele");
  } else {
    title = gettext.$gettext("Magazín o sběratelství");
  }

  return title;
};
